import { useMemo, useState, useEffect, useCallback } from 'react';

import { useAuthContext } from 'src/auth/hooks';

import { WorkspaceContext } from './workspace-context';

// ----------------------------------------------------------------------
type Props = {
  children: React.ReactNode;
};

export function WorkspaceProvider({ children }: Props) {
  const { employerOrgs } = useAuthContext();
  const [orgGuid, setOrgGuid] = useState<string>('');

  useEffect(() => {
    const storedOrgGuid = localStorage.getItem('selectedOrgGuid');
    const validOrgGuids = employerOrgs?.map((org) => org.guid) || [];

    if (storedOrgGuid && validOrgGuids.includes(storedOrgGuid)) {
      setOrgGuid(storedOrgGuid);
    } else if (validOrgGuids.length > 0) {
      setOrgGuid(validOrgGuids[0]);
      localStorage.setItem('selectedOrgGuid', validOrgGuids[0]);
    }
  }, [employerOrgs]);

  const handleSetOrgGuid = useCallback(
    (newOrgGuid: string) => {
      if (newOrgGuid) {
        setOrgGuid(newOrgGuid);
        localStorage.setItem('selectedOrgGuid', newOrgGuid);
      } else {
        console.error('Invalid organization selected');
      }
    },
    [setOrgGuid]
  );

  const memoizedValue = useMemo(
    () => ({
      orgGuid,
      setOrgGuid: handleSetOrgGuid,
    }),
    [handleSetOrgGuid, orgGuid]
  );

  return <WorkspaceContext.Provider value={memoizedValue}>{children}</WorkspaceContext.Provider>;
}
